import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo, LogoSmallImg, logowhite } from "../_components/Imagepath";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const Header = (props) => {
  const histroy = useHistory();

  const [UserDetails, setUser] = useState({ name: "no", user_type: "" });

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    // eslint-disable-next-line react/prop-types
    props.onMenuClick();
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    // console.log = function() {};
    try {
      const user = localStorage.getItem("User");
      console.log(JSON.parse(user));
      setUser(JSON.parse(user));
    } catch (err) {
      console.log("user data not found", err);
    }
  }, []);

  //logout function
  const HandleLogOut = () => {
    localStorage.clear();
    histroy.replace("/login");
  };
  //capitalize
  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <div className="header header-one">
      <Link
        to="/"
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo "
      >
        <div className="logo-white">
          <img src={logowhite} className="img-fluid logo-blue" alt="Logo" />
        </div>
        <div className="logo-color">
          <img src={Logo} className="img-fluid logo-blue" alt="Logo" />
        </div>
      </Link>

      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to="/">
            <img src={logowhite} className="img-fluid logo-blue" alt="Logo" />
          </Link>
          <Link to="/">
            <img
              src={LogoSmallImg}
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
        <div className="logo-color">
          <Link to="/">
            <img src={Logo} className="img-fluid logo-blue" alt="Logo" />
          </Link>
          <Link to="/">
            <img
              src={LogoSmallImg}
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <Link to="" id="toggle_btn" onClick={handlesidebar}>
        <span className="toggle-bars">
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
        </span>
      </Link>
      {/* /Sidebar Toggle */}
      {/* Mobile Menu Toggle */}
      <Link
        to=""
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <i className="fas fa-bars" />
      </Link>
      {/* /Mobile Menu Toggle */}
      {/* Header Menu */}
      <ul className="nav nav-tabs user-menu">
        <li className="nav-item  has-arrow dropdown-heads ">
          <Link to="" className="win-maximize">
            <i className="fe fe-maximize" />
          </Link>
        </li>
        {/* User Menu */}
        <li className="nav-item dropdown">
          <Link to="" className="user-link  nav-link" data-bs-toggle="dropdown">
            <span className="user-content">
              <span className="user-name">
                {UserDetails.name !== null ? UserDetails.name : "user"}
              </span>
              <span className="user-details">
                {UserDetails.user_type !== null
                  ? capitalize(UserDetails.user_type)
                  : "user"}
              </span>
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilemenu">
              <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                    <button className="dropdown-item" onClick={HandleLogOut}>
                      Log Out
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>
  );
};
export default Header;
